import type { FunctionComponent, SVGProps } from 'react'
import React from 'react'

export const Logo: FunctionComponent<LogoProps> = ({ className, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="70"
    height="15"
    viewBox="0 0 70 15"
    data-testid="sb-logo"
    className={className}
    {...rest}
  >
    <defs>
      <polygon id="a" points="0 0 10.321 0 10.321 9.883 0 9.883" />
      <polygon id="c" points="0 15 69.606 15 69.606 0 0 0" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <polygon
        fill="#000"
        points="14.552 .241 12.822 9.243 12.799 9.243 10.97 .241 7.497 .241 5.688 9.243 5.668 9.243 3.937 .241 0 .241 3.344 14.74 7.302 14.74 9.16 5.859 9.181 5.859 11.078 14.74 14.993 14.74 18.338 .241"
      />
      <g transform="translate(59.285)">
        <path
          fill="#000"
          d="M3.4211387,9.88319194 L3.4211387,9.50245526 C3.4211387,8.09292416 4.02182402,7.18830846 4.89978815,6.39586364 C5.06716585,6.24613162 5.23886345,6.10804135 5.40558219,5.97390489 C5.98788964,5.505672 6.4988822,5.07741646 6.4988822,4.41552039 C6.4988822,3.65682934 5.99147736,3.20389913 5.18204583,3.20389913 C4.44422208,3.20389913 3.88139076,3.672791 3.63779251,4.49013013 L3.60740679,4.59256294 L8.32399015e-15,4.59256294 C0.265051302,1.62677067 2.52179473,0 5.48539045,0 C8.33249539,0 10.3207462,1.6083928 10.3207462,3.99092578 C10.3207462,5.61564632 9.41481261,6.43152109 8.61526559,7.15140629 C7.64812121,8.03566722 7.18428143,8.70861929 7.16568391,9.5057501 L7.16238907,9.88319194 L3.4211387,9.88319194 Z"
          mask="url(#b)"
        />
      </g>
      <polygon
        fill="#E81C30"
        points="58.26 14.738 66.448 14.738 66.448 11.44 58.26 11.44"
        mask="url(#d)"
      />
      <path
        fill="#000"
        d="M52.7804272 14.7399568 52.7804272 8.48342819C52.7804272 6.94569133 51.2498658 6.50476897 50.4891246 7.9029512 50.2255377 8.38751184 50.1007 9.09289975 50.1007 10.0500864L50.1007 14.7399568 46.3896157 14.7399568 46.3896157.241284547 50.1007.241284547 50.1007 6.56759052C51.3381674 3.94548632 54.2509494 3.61138988 55.6877178 5.20477288 56.2099128 5.78385872 56.4915115 6.6175256 56.4915115 7.68849394L56.4915115 14.7399568 52.7804272 14.7399568ZM25.470017 14.7399568 25.470017 8.48342819C25.470017 6.94569133 23.9394555 6.50476897 23.1787144 7.9029512 22.9151274 8.38751184 22.7902898 9.09289975 22.7902898 10.0500864L22.7902898 14.7399568 19.0792054 14.7399568 19.0792054.241284547 22.7902898.241284547 22.7902898 6.56759052C24.0277572 3.94548632 26.9405392 3.61138988 28.3773076 5.20477288 28.8995026 5.78385872 29.1811013 6.6175256 29.1811013 7.68849394L29.1811013 14.7399568 25.470017 14.7399568Z"
        mask="url(#d)"
      />
      <polygon
        fill="#000"
        points="30.625 14.74 34.337 14.74 34.337 4.504 30.625 4.504"
        mask="url(#d)"
      />
      <path
        fill="#000"
        d="M45.3754942 10.9473363C45.2177082 13.25072 43.4783273 14.9999854 40.7666768 14.9999854 37.4949772 14.9999854 35.463747 12.9391749 35.463747 9.6220798 35.463747 6.35433405 37.5126961 4.24417424 40.6858434 4.24417424 43.1884549 4.24417424 45.1250134 5.49643181 45.328195 8.2850351L42.1097254 8.2850351C41.9696582 7.59868402 41.5910449 6.88282585 40.6977048 6.88282585 39.271846 6.88282585 39.0431111 8.63406812 39.0431111 9.6220798 39.0431111 10.8191306 39.374352 12.3475687 40.6917741 12.3475687 41.3484717 12.3475687 41.8533139 11.8249343 42.1037947 10.9473363L45.3754942 10.9473363ZM32.4791742 3.82348218C31.456164 3.82348218 30.4206335 3.1702259 30.4206335 1.9214096 30.4206335.659926489 31.456164.00000732185917 32.4791742.00000732185917 33.5019647.00000732185917 34.537422.659926489 34.537422 1.9214096 34.537422 3.1702259 33.5019647 3.82348218 32.4791742 3.82348218"
        mask="url(#d)"
      />
    </g>
  </svg>
)

type LogoProps = {
  className?: string
} & SVGProps<SVGSVGElement>
